import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-container block has-text-centered" }
const _hoisted_2 = { class: "content-container block has-text-centered" }
const _hoisted_3 = { class: "title mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle is-marginless"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: _ctx.logoUrl,
        alt: "Infigo",
        width: "200"
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}